import moment from 'moment';
import { removeCapacityReservationsForOrder, getEarliestDeliveryDate } from '../modules/prodplanningdata';

const dayjs = require('dayjs');
var isoWeek = require('dayjs/plugin/isoWeek');
var advancedFormat = require('dayjs/plugin/advancedFormat');
var isSameOrBefore = require('dayjs/plugin/isSameOrBefore');
dayjs.extend(isoWeek);
dayjs.extend(advancedFormat);
dayjs.extend(isSameOrBefore);
require('dayjs/locale/fi');
var utc = require('dayjs/plugin/utc');
dayjs.extend(utc);

export function generateContinuousWeekList(startWeek, endWeek, inclusive = true) {
    if (!inclusive) throw new Error('param error');

    let weeks = [];
    const startY = getYearFromIdentifier(startWeek);
    const startW = getWeekFromIdentifier(startWeek);

    let year = startY;
    let week = startW;
    let weeksInYear = moment(`${startY}-01-01`).weeksInYear();
    let id = '';
    do {
        id = formatWeekIdentifierInt(year, week);
        weeks.push(`${id}`);
        if (week === weeksInYear) {
            year++;
            week = 1;
            weeksInYear = moment(`${year}-01-01`).weeksInYear();
        } else {
            week++;
        }
    } while (id < endWeek);
    return weeks;
}

export function getWeekFromIdentifier(id) {
    const week = id.split('-')[1];
    return parseInt(week);
}

export function getYearFromIdentifier(id) {
    const year = id.split('-')[0];
    return parseInt(year);
}

export function formatWeekIdentifierDayjs(dayjsObj) {
    return dayjsObj.format('YYYY-WW');
}

export function formatWeekIdentifierMoment(momentObj) {
    const dj = dayjs(momentObj.format());
    const ret = dj.format('YYYY-WW');
    return ret;
}

export function formatWeekIdentifierInt(year, week) {
    if (week < 10) week = `0${week}`;
    return `${year}-${week}`;
}

export async function earliestDeliveryDateForOrder(store, orders) {
    let dates = {};
    try {
        dates = await getEarliestDeliveryDate(orders.map((o) => o.id));
    } catch (err) {
        console.log(err);
        return null;
    }
    return dates;
}

export async function removeCapacityReservations(store, orderId) {
    await removeCapacityReservationsForOrder(orderId)(store.dispatch);
}
